var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('Grid',{attrs:{"title":"Tokens","headers":_vm.headers,"hasBtnAdd":false,"items":_vm.tokens},on:{"destroy":_vm.destroyToken,"atualiza":_vm.getTokens}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }